import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getUserFullNameFromEmail } from "../../../utils/functions/getUserFullNameFromEmail";
import Txt from "../../typography/Txt";

const CellRendererUserByEmail = (params) => {
  const users = useSelector((state) => state?.users);
  const userEmail = useMemo(() => params?.value, [params?.value]);

  const userNameFromEmail = useMemo(
    () => getUserFullNameFromEmail(users, userEmail),
    [userEmail, users],
  );

  // Prefer the resolved full name; when there's no name but we have an email,
  // show the email itself (never "Unknown"). The "<email>" suffix is dropped.
  const display =
    userNameFromEmail && String(userNameFromEmail).trim()
      ? userNameFromEmail
      : userEmail;

  if (!display) return null;

  return (
    <TextEllipsisWrapper stacked={params?.stacked}>
      {/* Ellipsis must live on the text element itself — Txt renders a <p>
          (block), so text-overflow on the wrapper alone has no effect. */}
      <Txt
        sx={{
          fontSize: "inherit",
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
        }}
      >
        {display}
      </Txt>
    </TextEllipsisWrapper>
  );
};
const TextEllipsisWrapper = ({
  children,
  multiLine = false,
  maxLines = 3,
  style,
  stacked = false,
  className,
  ...props
}) => {
  const ellipsisStyle = multiLine
    ? {
        // Multi-line ellipsis
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        wordWrap: "break-word",
      }
    : {
        // Single-line ellipsis
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
      };

  const stackedStyle = stacked
    ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }
    : {};

  return (
    <div
      style={{
        ...ellipsisStyle,
        ...stackedStyle,
        ...style,
      }}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};
export default CellRendererUserByEmail;
